<div class="modal-full-screen full-width bg-white">
    <div class="inner">
        <div>
            <div class="page-header-banner">
                <h1>Supplier Setup</h1>
                <a (click)="cancel()" class="closeBtnBig">
                    x
                </a>
            </div>
            <div class="container mt-100">
                <div class="row justify-content-center mb-5">
                    <div class="col-12 col-xl-10">
                        <div class="steps" *ngIf="!steps.confirmation.active">
                            <div class="progress">
                                <div class="progress-bar bg-info"
                                     role="progressbar"
                                     [ngClass]="{
                                'w-0': steps.supplier.active,
                                'w-20': steps.address.active,
                                'w-40': steps.user.active,
                                'w-60': steps.range.active,
                                'w-80': steps.productTypes.active,
                                'w-100': steps.optionsPricing.active
                             }"></div>
                            </div>
                            <div class="step-item">
                                <button (click)="barNav('supplier')"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.supplier.active,
                                    'btn-info' : steps.supplier.completed,
                                    'btn-light' : !steps.supplier.active && !steps.supplier.completed
                                }"
                                        type="button">
                                    1
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.supplier.active,
                                    'text-primary' : steps.supplier.completed,
                                    'text-muted' : !steps.supplier.active && !steps.supplier.completed
                                }">
                                    Company<br>Details
                                </div>
                            </div>
                            <div class="step-item">
                                <button (click)="barNav('address')"
                                        [disabled]="!company.id"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.address.active,
                                    'btn-info' : steps.address.completed,
                                    'btn-light' : !steps.address.active && !steps.address.completed
                                }"
                                        type="button">
                                    2
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.address.active,
                                    'text-primary' : steps.address.completed,
                                    'text-muted' : !steps.address.active && !steps.address.completed
                                }">
                                    Company<br>Address
                                </div>
                            </div>
                            <div class="step-item">
                                <button (click)="barNav('user')"
                                        [disabled]="!company.name && !company.email"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.user.active,
                                    'btn-info' : steps.user.completed,
                                    'btn-light' : !steps.user.active && !steps.user.completed
                                }"
                                        type="button">
                                    3
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.user.active,
                                    'text-primary' : steps.user.completed,
                                    'text-muted' : !steps.user.active && !steps.user.completed
                                }">
                                    Primary<br>Contact
                                </div>
                            </div>
                            <div class="step-item" *ngIf="mode === 'account'">
                                <button (click)="barNav('range')"
                                        [disabled]="!company.id"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.range.active,
                                    'btn-info' : steps.range.completed,
                                    'btn-light' : !steps.range.active && !steps.range.completed
                                }"
                                        type="button">
                                    4
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.range.active,
                                    'text-primary' : steps.range.completed,
                                    'text-muted' : !steps.range.active && !steps.range.completed
                                }">
                                    Product<br>Range
                                </div>
                            </div>
                            <div class="step-item" *ngIf="mode === 'account'">
                                <button (click)="barNav('productTypes')"
                                        [disabled]="!productRange"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.productTypes.active,
                                    'btn-info' : steps.productTypes.completed,
                                    'btn-light' : !steps.productTypes.active && !steps.productTypes.completed
                                }"
                                        type="button">
                                    5
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.productTypes.active,
                                    'text-primary' : steps.productTypes.completed,
                                    'text-muted' : !steps.productTypes.active && !steps.productTypes.completed
                                }">
                                    Product<br>Types
                                </div>
                            </div>
                            <div class="step-item" *ngIf="mode === 'account'">
                                <button (click)="barNav('optionsPricing')"
                                        [disabled]="!productRange"
                                        class="step-button text-center mb-2"
                                        [ngClass]="{
                                    'btn-primary' : steps.optionsPricing.active,
                                    'btn-info' : steps.optionsPricing.completed,
                                    'btn-light' : !steps.optionsPricing.active && !steps.optionsPricing.completed
                                }"
                                        type="button">
                                    6
                                </button>
                                <div class="small"
                                     [ngClass]="{
                                    'text-primary fw-bold' : steps.optionsPricing.active,
                                    'text-primary' : steps.optionsPricing.completed,
                                    'text-muted' : !steps.optionsPricing.active && !steps.optionsPricing.completed
                                }">
                                    Masonry<br>Pricing
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="!doReset && !steps.confirmation.active">
                    <app-supplier [company]="company" *ngIf="steps.supplier.active"
                                  (next)="setStep('address', 'supplier')"></app-supplier>
                    <app-address [address]="address" *ngIf="steps.address.active"
                                 (next)="setStep('user', 'address')"></app-address>
                    <app-user [newRecord]="newRecord" [user]="user" [company]="company" [address]="address" [entryType]="mode"
                              *ngIf="steps.user.active" (userCreated)="userCreated($event)"
                              (next)="setStep('range', 'user')"></app-user>
                    <!-- <app-base-costs [supplierId]="user.company.id" *ngIf="steps.baseCosts.active" (next)="setStep('range', 'baseCosts')"></app-base-costs> -->
                    <app-range [productRange]="productRange" [company]="company" *ngIf="steps.range.active"
                               (productRangeUpdated)="productRangeUpdated($event)"
                               (next)="setStep('productTypes', 'range')"></app-range>
                    <app-product-types [productRange]="productRange" *ngIf="steps.productTypes.active"
                                       (productRangeUpdated)="productRangeUpdated($event)"
                                       (next)="setStep('optionsPricing', 'productTypes')"
                                       (exitStep)="exitStep('range', 'productTypes')"></app-product-types>
                    <app-options-pricing [supplierId]="user.company.id" *ngIf="steps.optionsPricing.active"
                                         (next)="setStep('confirmation', 'optionsPricing')"
                                         (exitStep)="exitStep('optionsPricing', 'productTypes')"></app-options-pricing>
                </ng-container>

                <ng-container *ngIf="steps.confirmation.active">
                    <div class="text-center mt-100">
                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                        </svg>
                        <h1 class="mt-50">Supplier setup completed</h1>

                        <h4 class="mt-50">Would you like to exit supplier process or create a new product for this
                            supplier?</h4>
                        <div class="row mt-50">
                            <div class="col-6 text-center">
                                <button class="btn btn-round btn-primary" (click)="cancel()">Close</button>
                            </div>
                            <div class="col-6 text-center">
                                <button class="btn btn-round btn-primary" (click)="addProduct()">Add a Product</button>
                            </div>
                        </div>
                    </div>
                </ng-container>


            </div>

        </div>

    </div>

</div>
